import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./layout";
import Introduce from './introduce'
import Lcm_tour from './lcm_tour';
import Booking_tour from './booking_tour';
import Hot_tour_team from './hot_tour_team';
import Shorttrek from './Shorttrek';

function App() {
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Introduce />} />
          <Route path="lcm" element={<Lcm_tour />} />
          <Route path="book" element={<Booking_tour />} />
          <Route path="tour" element={<Hot_tour_team />} />
          <Route path="short" element={<Shorttrek />} />
        </Route>
      </Routes>
   </BrowserRouter>
  )
}


export default App